import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";
import InternalChatNotificationListener from "../../components/InternalChatNotificationListener";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading,
		user,
		isAuth,
		handleLogin,
		handleLogout,
		socket,
		modulePermissions,
		modulePermissionsLoaded,
		refreshModulePermissions,
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading,
				user,
				isAuth,
				handleLogin,
				handleLogout,
				socket,
				modulePermissions,
				modulePermissionsLoaded,
				refreshModulePermissions,
			}}
		>
			<InternalChatNotificationListener socket={socket} user={user} />
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
